import { createAction } from 'redux-starter-kit';

/**
 * An action creator for putting a currency report in the state
 * @param {object[]} report The report to add/replace
 * @example dispatch(putCurrencyReport(report))
 */
export const putCurrencyReport = createAction('PUT_CURRENCY_REPORT');

/**
 * An action creator for replacing all currency reports in the state
 * @param {object[]} reports A list of currency reports.
 * @example dispatch(putCurrencyReports(reports))
 */
export const putCurrencyReports = createAction('PUT_CURRENCY_REPORTS');

/**
 * An action creator for putting a tax report region in the state
 * @param {object[]} report The report to add/replace
 * @example dispatch(putCurrencyReport(report))
 */
export const putTaxReportRegion = createAction('PUT_TAX_REPORT_REGION');

/**
 * An action creator for replacing all tax report regions in the state
 * @param {object[]} reports A list of currency reports.
 * @example dispatch(putCurrencyReports(reports))
 */
export const putTaxReportRegions = createAction('PUT_TAX_REPORT_REGIONS');
